module.exports = __webpack_public_path__ + "static/media/moon_yellow-min.853896e2.png";